module.exports = __webpack_public_path__ + "static/media/Cari Kelly_1666122583057.8c5ae1d9.png";